import { InstantSearch, Configure, Index } from 'react-instantsearch-dom'
import { connectStateResults, connectAutoComplete } from 'react-instantsearch/connectors'
import preact from 'preact'

import globals from 'utils/globals'
import { SEARCH_TOKEN_URL } from '../../../libs/config'
import getWithInMemoryCache from '../../../utils/getWithInMemoryCache'
import AlgoliaSearch from './AlgoliaSearch'
import AlgoliaSearchForControl from './AlgoliaSearchForControl'

const SearchWithAutoComplete = connectAutoComplete(connectStateResults(AlgoliaSearch))
const SearchWithAutoCompleteForControl = connectAutoComplete(connectStateResults(AlgoliaSearchForControl))

class Search extends preact.Component {
  constructor (props) {
    super(props)
    this.state = { searching: false, searchById: false }
    this.updateSearch = this.updateSearch.bind(this)
  }

  updateSearch (value, next) {
    this.setState({ searching: value !== '', searchById: !isNaN(value), finalInput: value }, next)
  }

  componentDidMount () {
    getWithInMemoryCache(SEARCH_TOKEN_URL, {}).then(data => this.setState({
      clientId: data['client_id'],
      token: data.token
    }, () => {
      if (typeof window.aa === 'function') {
        window.aa('init', {
          applicationID: this.state.clientId,
          apiKey: this.state.token
        })
      }
    }))
  }

  render (props, state) {
    if (!state.clientId) return
    return <PureSearch updateSearch={this.updateSearch}
      searchById={state.searchById}
      finalInput={state.finalInput}
      appId={state.clientId}
      apiKey={state.token}
      searching={state.searching}
      communityId={globals('communityId')}
      {...props} />
  }
}

const PureSearch = (props) => <InstantSearch
  appId={props.appId}
  apiKey={props.apiKey}
  indexName={props.communityId}
>
  <Index indexName={props.communityId}>
    <Configure
      hitsPerPage={5}
      clickAnalytics={props.searching}
      analyticsTags={props.isControl ? ['control'] : ['destination', 'live']}
      restrictSearchableAttributes={props.searchById ? ['id'] : ['title', 'first_post', 'answer', 'reply', 'tags', 'forum_title', 'category_title']} />
  </Index>

  {
    props.isFederatedSearch ? (
      <Index indexName={`${props.communityId}-zendesk`}>
        <Configure
          hitsPerPage={3}
          clickAnalytics={props.searching} />
      </Index>
    ) : null
  }

  {
    props.isControl ? (
      <SearchWithAutoCompleteForControl
        updateSearch={(value, next) => props.updateSearch(value, next)}
        searchById={props.searchById}
        finalInput={props.finalInput}
        placeholder={props.searchPlaceholder}
        callback={props.callback}
        exclude={props.exclude}
      />
    ) : (
      <SearchWithAutoComplete
        updateSearch={(value, next) => props.updateSearch(value, next)}
        callback={props.callback}
        indexName={props.communityId}
        isFederatedSearch={props.isFederatedSearch}
      />
    )
  }
</InstantSearch>

export { PureSearch }
export default Search
